import { render, staticRenderFns } from "./MoneyNotMatching.vue?vue&type=template&id=16b7f2bc&"
import script from "./MoneyNotMatching.vue?vue&type=script&lang=js&"
export * from "./MoneyNotMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports